import { render } from "./MoveOrders.vue?vue&type=template&id=a55617d4&scoped=true"
import script from "./MoveOrders.vue?vue&type=script&lang=js"
export * from "./MoveOrders.vue?vue&type=script&lang=js"

import "./MoveOrders.vue?vue&type=style&index=0&id=a55617d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55617d4"]])

export default __exports__